export default __webpack_public_path__ + "static/media/pd.9d09a7ab.png";